import { render, staticRenderFns } from "./company_create_form.vue?vue&type=template&id=da144c6e&scoped=true"
import script from "./company_create_form.vue?vue&type=script&lang=ts"
export * from "./company_create_form.vue?vue&type=script&lang=ts"
import style0 from "./company_create_form.vue?vue&type=style&index=0&id=da144c6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da144c6e",
  null
  
)

export default component.exports